import { useState, useEffect } from 'react';

/**
 * Check if staging mode is enabled via environment variables
 */
export const isStaging = () => {
	return (
		process.env.REACT_APP_STAGING === 'true' ||
		process.env.REACT_APP_STAGING === '1' ||
		process.env.REACT_APP_IS_STAGING === 'true' ||
		process.env.REACT_APP_STAGE === 'true' ||
		process.env.REACT_APP_ENV === 'staging' ||
		process.env.REACT_APP_MODE === 'staging'
	);
};

/**
 * Get AJAX server URL (https://stage.sv-nn.com when staging is active)
 */
export const getAjaxServer = () => {
	if (isStaging()) {
		return 'https://stage.sv-nn.com';
	}
	return process.env.REACT_APP_AJAX_SERVER || 'https://sv-nn.com';
};

/**
 * Custom hook for staging slogan text & style blinking every 3 seconds
 */
export const useStagingSlogan = (defaultText) => {
	const [isAlert, setIsAlert] = useState(false);
	const stagingActive = isStaging();

	useEffect(() => {
		if (!stagingActive) return;

		const interval = setInterval(() => {
			setIsAlert((prev) => !prev);
		}, 3000);

		return () => clearInterval(interval);
	}, [stagingActive]);

	if (stagingActive && isAlert) {
		return {
			text: 'staging окружение и БД',
			style: { color: 'red' }
		};
	}

	return {
		text: defaultText,
		style: {}
	};
};
